// @flow
import React, { type Node, PureComponent } from "react";
import { TopTracksWrapper, Title } from "./styled-components";

type Props = {
  title: string,
  children: Node[],
  showHeader?: boolean
};

class TopTracks extends PureComponent<Props> {
  static defaultProps = {
    title: "Top Tracks",
    children: [],
    showHeader: true
  };

  render = () => {
    if (!this.props.children.length) {
      return null;
    }

    return this.props.showHeader ? (
      <TopTracksWrapper>
        <Title>{this.props.title}</Title>
        {this.props.children}
      </TopTracksWrapper>
    ) : (
      this.props.children
    );
  };
}

export default TopTracks;
